import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";

const fireBaseBackend = getFirebaseBackend();

// export const userForgetPassword = (user, history) => async (dispatch) => {
//   try {
//     let response;
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       response = fireBaseBackend.forgetPassword(user.email);
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       response = postJwtForgetPwd(user.email);
//     } else {
//       response = postFakeForgetPwd(user.email);
//     }

//     const data = await response;

//     if (data) {
//       dispatch(
//         userForgetPasswordSuccess(
//           "Reset link are sended to your mailbox, check there first"
//         )
//       );
//     }
//   } catch (forgetError) {
//     dispatch(userForgetPasswordError(forgetError));
//   }
// };
export const forgetPassword = (email, history) => async (dispatch) => {
  try {
    const fireBaseBackend = getFirebaseBackend();

    const response = await fireBaseBackend.forgetPassword(email);
    console.log(response);
    if (response) {
      dispatch(
        userForgetPasswordSuccess(
          "Reset link are sended to your mailbox, check there first"
        )
      );
    }
    return { success: true };
  } catch (forgetError) {
    dispatch(userForgetPasswordError(forgetError));
    console.log(forgetError);
    throw forgetError;
  }
};
